import type { Editor } from "@tiptap/core"

export const suggestionPopupTarget = (editor: Editor): HTMLElement =>
	editor.view.dom.closest<HTMLElement>("[role='dialog']") ?? document.body
